import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, signal } from '@angular/core';

import { User } from '@cxc/core/models';

import { UserStore } from '@cxc/core/services';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './home.component.html',
})
export class HomePageComponent implements AfterViewInit {
  user = signal<User | null>(null);
  constructor(private userStore: UserStore) {}

  ngAfterViewInit() {
    this.user.set(this.userStore.get());
  }
}
